import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileText = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 9l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 13l6 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 17l6 0" })
	]
});
export { SvgFileText as ReactComponent };
